import { map } from "lodash"
import PropTypes from "prop-types"
import classNames from "classnames"
import { Paper, Grow, List, CircularProgress, ClickAwayListener, IconButton } from "@mui/material"
import Tooltip from "components/material/tooltip"
import { Notifications, NotificationsOutlined } from "@mui/icons-material"
import { NOTIFICATION } from "./shapes"
import { NOTIFICATION_STATUSES } from "./helpers"
import InProgress from "./components/in-progress"
import Success from "./components/success"
import Waiting from "./components/waiting"
import Error from "./components/error"
import Download from "./components/download"

import "./styles.scss"

function getListItem(notification) {
  switch (notification.status) {
    case NOTIFICATION_STATUSES.FILE_DOWNLOAD:
      return <Download key={notification.id} {...notification} />
    case NOTIFICATION_STATUSES.ERROR:
      return <Error key={notification.id} {...notification} />
    case NOTIFICATION_STATUSES.SUCCESS:
      return <Success key={notification.id} {...notification} />
    case NOTIFICATION_STATUSES.IN_PROGRESS:
      return <InProgress key={notification.id} {...notification} />
    default:
      return <Waiting key={notification.id} {...notification} />
  }
}

function ServerNotifications({ homeVersion, open, toggle, notifications, averageCompletion }) {
  return <ClickAwayListener onClickAway={open ? toggle : () => {}}>
    <div>
      <Tooltip title="Notifications">
        <div>
          {homeVersion
            ? <IconButton onClick={toggle} className="notifications" size="large">
              <NotificationsOutlined />
              {averageCompletion && <CircularProgress
                variant="determinate"
                color="white"
                value={averageCompletion * 100}
                style={{ position: "absolute", transform: "scale(0.78, 0.78) rotate(270deg) translate(-1px, 0)" }}
              />}
            </IconButton>
            : <div style={{ height: "3rem" }} onClick={toggle} className={classNames("notifications", { open })}>
              <NotificationsOutlined classes={{ root: "bell-icon" }} />
              {averageCompletion && <CircularProgress
                variant="determinate"
                color="white"
                value={averageCompletion * 100}
                style={{ position: "absolute", transform: "scale(0.78, 0.78) rotate(270deg) translate(-1px, 0)" }}
              />}
            </div>}
          <Grow in={open}>
            <Paper elevation={8} className={classNames("modules_server-notifications", { open })}>
              <div className="header" color="secondary">
                Notifications
              </div>

              {!notifications.length && <div className="no-notifications">
                <Notifications className="icon" />
                <div className="title">Your notifications live here</div>
                <div className="message">
                  You&apos;ll be notified of the status of any relevant notifications right here.
                </div>
                <div className="message">
                  (for example file uploads)
                </div>
              </div>}

              {!!notifications.length
                && <div className="list-container">
                  <List>
                    {map(notifications, n => getListItem(n))}
                  </List>
                </div>}
            </Paper>
          </Grow>
        </div>
      </Tooltip>
    </div>
  </ClickAwayListener>
}

ServerNotifications.propTypes = {
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  notifications: PropTypes.arrayOf(NOTIFICATION),
  averageCompletion: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
  homeVersion: PropTypes.bool,
}

export default ServerNotifications
